import React from "react";
import { checkShowOnDevice } from "../../utils";
import { useDetectOS } from "../../hooks";
import { StillHaveQuestionItem, } from "../StillHaveQuestionsItems/StillHaveQuestionItem";
export const ContactOptions = ({ contactOptions, qrCodeUrl, }) => {
    const { isMobileOS } = useDetectOS();
    const mustShowQRCode = qrCodeUrl && isMobileOS === false;
    return (React.createElement("div", { className: "contact-options-root" },
        React.createElement("div", { className: "contact-options-root__itemWrapper" }, contactOptions.length > 0 &&
            contactOptions
                .filter((option) => checkShowOnDevice(option.devicesToShowOn, isMobileOS))
                .map((option) => (React.createElement(StillHaveQuestionItem, { key: `unique${option.title}`, title: option.title, imgUrl: option.imgUrl, imgAlt: option.imgAlt, linkUrl: option.linkUrl })))),
        mustShowQRCode && (React.createElement("img", { className: "contact-options-root__QRcode-image", src: qrCodeUrl, alt: "WhatsApp QR code" }))));
};
